export default "__VITE_ASSET__BjCj5TzO__"